import React from 'react';
import styled from 'styled-components';
import CellContainer from '../CellContainer';
import EvolutionIcon from '../../EvolutionIcon';

const ValueContainer = styled.div`
  margin-left: 4px;
`;

const Cell = ({ value, ...otherProps }) => (
  <CellContainer {...otherProps}>
    <EvolutionIcon icon={value && value.evolution ? value.evolution : value} />
    {value && value.value && <ValueContainer>{value.value}</ValueContainer>}
  </CellContainer>
);

export default Cell;
